import { useContext } from 'react';

export function createContextHook<T>(Context: React.Context<T>) {
    return () => {
        const context = useContext<T>(Context);

        if (!context) {
            throw new Error(`${Context.displayName} is not found!`);
        }

        return context;
    };
}
